export const voleoRequestsHeaderElements = [
  { label: "Titular cuenta", value: "titularCuenta" },
  { label: "Tipo servicio", value: "tipoServicio" },
  { label: "Establecimiento y Hectárea", value: "displayEstablecimiento" },
  { label: "Estado", value: "displayEstado" },
];
